import React from "react";
import axios from "axios";

import Table from "../../common/Table";
import { renderOrderStatus, renderPaymentOption } from "../../utils/actions";
import { BACKEND_CONFIG } from "../../config/consts";
import ClientBackHeader from "../../components/ClientBackHeader";
import { formatDateString } from "../../utils/format";

export class Orders extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      orders: [],
      redirectUrl: "",
    };
  }

  componentDidMount() {
    axios
      .get(
        `${BACKEND_CONFIG.apiUrl}agency/clients/${this.props.match.params.clientId}/orders`
      )
      .then((data) => {
        this.setState({ orders: data.data });
      });
  }

  render() {
    return (
      <div className="service-request-submit">
        <ClientBackHeader
          clientId={this.props.match.params.clientId}
          goBack={() => this.props.history.goBack()}
        />
        <h1 className="page-header">Bind Requests</h1>
        <Table
          className="form-group"
          paging={false}
          ref="table"
          data={this.state.orders}
          columnDefs={[
            {
              data: "OrderId",
              width: "auto",
              autowidth: true,
              title: "Order Number",
              targets: [0],
              defaultContent: "",
              className: "",
            },
            {
              data: "OrderType",
              width: "auto",
              autowidth: true,
              title: "Order Type",
              targets: [1],
              defaultContent: "",
              className: "",
            },
            {
              data: "QuoteIdInt",
              width: "auto",
              autowidth: true,
              title: "Policy ID",
              targets: [2],
              defaultContent: "",
              className: "",
            },
            {
              data: "LineOfBusiness",
              width: "auto",
              autowidth: true,
              title: "LOB",
              targets: [3],
              defaultContent: "",
              className: "",
            },
            {
              data: "Carrier",
              width: "auto",
              autowidth: true,
              title: "Carrier",
              targets: [4],
              defaultContent: "",
              className: "",
            },
            {
              data: "RequestedBy",
              width: "auto",
              autowidth: true,
              title: "Requested By",
              targets: [5],
              defaultContent: "",
              className: "",
            },
            {
              data: "SubmittedDate",
              width: "110px",
              autowidth: false,
              title: "Submitted Date",
              targets: [6],
              render: formatDateString,
              defaultContent: "",
              className: "col-fw-110px",
            },
            {
              data: "EffectiveDate",
              width: "110px",
              autowidth: false,
              title: "Effective Date",
              targets: [7],
              render: formatDateString,
              defaultContent: "",
              className: "col-fw-110px",
            },
            {
              data: "PaymentPlan",
              width: "auto",
              autowidth: true,
              title: "Payment Plan",
              targets: [8],
              defaultContent: "",
              className: "",
            },
            {
              data: "PaymentOption",
              width: "auto",
              autowidth: true,
              title: "Payment Option",
              targets: [9],
              render: renderPaymentOption,
              defaultContent: "",
              className: "",
            },
            {
              data: "Status",
              width: "auto",
              autowidth: true,
              title: "Status",
              targets: [10],
              defaultContent: "",
              className: "",
              render: renderOrderStatus,
            },
          ]}
        />
      </div>
    );
  }
}
